<div class="mx-auto max-width-500">
    <ng-content></ng-content>
</div>
